import { render, staticRenderFns } from "./GradeSectionFilter.vue?vue&type=template&id=1edad8fa&"
import script from "./GradeSectionFilter.vue?vue&type=script&lang=js&"
export * from "./GradeSectionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports